import gql from 'graphql-tag';

export const removeUserMutation = gql`
  mutation RemoveUser($id: ID!) {
    removeUser(id: $id)
  }
`;